<script lang="ts" setup>
import type { SectionsSeparator } from '@autobid/strapi-integration/rest/components'
import { separator } from '@autobid/ui/utils/cva/separatorCva'

interface Props {
  data: Pick<SectionsSeparator, 'width' | 'borderStyle' | 'color'>
}

defineProps<Props>()
</script>

<template>
  <div class="flex-1">
    <div
      class="border-b"
      :class="
        separator({
          style: data.borderStyle,
          color: data.color?.name,
        })
      "
      :style="{
        borderBottomWidth: `${data.width}px`,
      }"
    />
  </div>
</template>
